import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';

const FiltrosSolicitudes = ({ onAplicarFiltros, onLimpiarFiltros, filtrosActivos }) => {
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({
    tipoSolicitud: '',
    estado: '',
    fechaInicio: '',
    fechaFin: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros(prev => ({ ...prev, [name]: value }));
  };

  const handleAplicar = () => {
    const filtrosLimpios = Object.fromEntries(
      Object.entries(filtros).filter(([_, value]) => value !== '')
    );
    onAplicarFiltros(filtrosLimpios);
  };

  const handleLimpiar = () => {
    setFiltros({
      tipoSolicitud: '',
      estado: '',
      fechaInicio: '',
      fechaFin: ''
    });
    onLimpiarFiltros();
  };

  const hayFiltrosActivos = Object.keys(filtrosActivos).length > 0;

  return (
    <div className="card border-0 shadow-sm mb-3 w-100">
      <div className="card-body w-100">
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => setMostrarFiltros(!mostrarFiltros)}
        >
          <i className={`bi bi-funnel me-2`}></i>
          {mostrarFiltros ? 'Ocultar' : 'Mostrar'} Filtros
          {hayFiltrosActivos && (
            <span className="badge bg-primary ms-2">
              {Object.keys(filtrosActivos).length}
            </span>
          )}
        </button>

        <Collapse in={mostrarFiltros}>
          <div className="mt-3">
            <div className="row g-3">
              <div className="col-md-3">
                <label className="form-label">Tipo de Solicitud</label>
                <select
                  name="tipoSolicitud"
                  className="form-select"
                  value={filtros.tipoSolicitud}
                  onChange={handleChange}
                >
                  <option value="">Todos</option>
                  <option value="permiso">Permiso</option>
                  <option value="vacaciones">Vacaciones</option>
                  <option value="insumo">Insumo</option>
                  <option value="dotacion">Dotación</option>
                  <option value="capacitacion">Capacitación</option>
                  <option value="incapacidad">Incapacidad</option>
                  <option value="compensatorio">Compensatorio</option>
                  <option value="teletrabajo">Teletrabajo</option>
                  <option value="reembolso">Reembolso</option>
                  <option value="equipamiento">Equipamiento</option>
                  <option value="mantenimiento">Mantenimiento</option>
                  <option value="otro">Otro</option>
                </select>
              </div>

              <div className="col-md-3">
                <label className="form-label">Estado</label>
                <select
                  name="estado"
                  className="form-select"
                  value={filtros.estado}
                  onChange={handleChange}
                >
                  <option value="">Todos</option>
                  <option value="pendiente">Pendiente</option>
                  <option value="en_revision">En Revisión</option>
                  <option value="aprobado">Aprobado</option>
                  <option value="rechazado">Rechazado</option>
                  <option value="cancelado">Cancelado</option>
                </select>
              </div>

              <div className="col-md-3">
                <label className="form-label">Fecha Inicio Desde</label>
                <input
                  type="date"
                  name="fechaInicio"
                  className="form-control"
                  value={filtros.fechaInicio}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">Fecha Fin Hasta</label>
                <input
                  type="date"
                  name="fechaFin"
                  className="form-control"
                  value={filtros.fechaFin}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <button
                  className="btn btn-primary me-2"
                  onClick={handleAplicar}
                >
                  <i className="bi bi-search me-2"></i>
                  Aplicar Filtros
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimpiar}
                >
                  <i className="bi bi-x-lg me-2"></i>
                  Limpiar
                </button>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default FiltrosSolicitudes;